/**
 * MenuItem is part of Menu and specifically a child of MenuContent.
 * MenuItems should have a 'key' prop specified.
 * https://facebook.github.io/react/docs/lists-and-keys.html#keys
 *
 * Example:
 *   <MenuItem key="item 1"><MenuAction icon="⚑">Report</MenuAction></MenuItem>
 *
 * `type` gives the board's other rows: a separator line, or a caption ("Acting as").
 */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import css from './MenuItem.module.css';

const MenuItem = props => {
  const { children, className, rootClassName, isHidden, type } = props;

  if (isHidden) {
    return null;
  }
  if (type === 'separator') {
    return <li role="separator" className={classNames(css.separator, className)} />;
  }
  if (type === 'caption') {
    return (
      <li role="presentation" className={classNames(css.caption, className)}>
        {children}
      </li>
    );
  }

  const classes = classNames(rootClassName || css.root, className);
  return (
    <li className={classes} role="menuitem">
      {children}
    </li>
  );
};

MenuItem.defaultProps = {
  children: null,
  className: null,
  rootClassName: null,
  isHidden: false,
  type: 'item',
};

const { node, string, bool, oneOf } = PropTypes;

MenuItem.propTypes = {
  children: node,
  className: string,
  rootClassName: string,
  isHidden: bool,
  type: oneOf(['item', 'separator', 'caption']),
};

export default MenuItem;
